import * as o from "react";
import t from "../lib/IconBase.es.js";
import f from "../defs/MapTrifold.es.js";
const r = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...a, weights: f }));
r.displayName = "MapTrifoldIcon";
const p = r;
export {
  p as MapTrifold,
  r as MapTrifoldIcon
};
